/**
 * Game Decoded Logo - Sports + Data Analytics Theme
 *
 * Design: Stylized "play diagram" with data circuit aesthetic
 * A ball shape formed by connected nodes - representing both
 * sports strategy and data network analysis.
 */

export function Logo({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="100%" stopColor="#a855f7" />
        </linearGradient>
        <linearGradient id="logoGradReverse" x1="100%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#a855f7" />
          <stop offset="100%" stopColor="#06b6d4" />
        </linearGradient>
      </defs>

      {/* Outer ring - stylized ball */}
      <circle
        cx="20" cy="20" r="16"
        stroke="url(#logoGrad)"
        strokeWidth="2.5"
        fill="none"
      />

      {/* Inner data network - play diagram style */}
      <g stroke="url(#logoGrad)" strokeWidth="1.5" strokeLinecap="round">
        {/* Horizontal connection */}
        <line x1="10" y1="20" x2="30" y2="20" opacity="0.5" />
        {/* Vertical connection */}
        <line x1="20" y1="10" x2="20" y2="30" opacity="0.5" />
        {/* Diagonal connections - X pattern */}
        <line x1="12" y1="12" x2="28" y2="28" opacity="0.4" />
        <line x1="28" y1="12" x2="12" y2="28" opacity="0.4" />
      </g>

      {/* Center node - the "decode" point */}
      <circle cx="20" cy="20" r="4" fill="url(#logoGrad)" />
      <circle cx="20" cy="20" r="2" fill="#0f172a" />

      {/* Corner data nodes */}
      <circle cx="12" cy="12" r="2.5" fill="url(#logoGrad)" />
      <circle cx="28" cy="12" r="2.5" fill="url(#logoGradReverse)" />
      <circle cx="12" cy="28" r="2.5" fill="url(#logoGradReverse)" />
      <circle cx="28" cy="28" r="2.5" fill="url(#logoGrad)" />

      {/* Edge nodes */}
      <circle cx="20" cy="10" r="2" fill="url(#logoGrad)" />
      <circle cx="30" cy="20" r="2" fill="url(#logoGradReverse)" />
      <circle cx="20" cy="30" r="2" fill="url(#logoGradReverse)" />
      <circle cx="10" cy="20" r="2" fill="url(#logoGrad)" />
    </svg>
  )
}

export function LogoMark({ size = 24, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="logoMarkGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="100%" stopColor="#a855f7" />
        </linearGradient>
      </defs>

      {/* Outer ring */}
      <circle
        cx="12" cy="12" r="10"
        stroke="url(#logoMarkGrad)"
        strokeWidth="2"
        fill="none"
      />

      {/* Cross lines */}
      <line x1="6" y1="12" x2="18" y2="12" stroke="url(#logoMarkGrad)" strokeWidth="1.5" opacity="0.5" />
      <line x1="12" y1="6" x2="12" y2="18" stroke="url(#logoMarkGrad)" strokeWidth="1.5" opacity="0.5" />

      {/* Center */}
      <circle cx="12" cy="12" r="3" fill="url(#logoMarkGrad)" />
      <circle cx="12" cy="12" r="1.5" fill="#0f172a" />

      {/* Corner nodes */}
      <circle cx="7" cy="7" r="1.5" fill="url(#logoMarkGrad)" />
      <circle cx="17" cy="7" r="1.5" fill="url(#logoMarkGrad)" />
      <circle cx="7" cy="17" r="1.5" fill="url(#logoMarkGrad)" />
      <circle cx="17" cy="17" r="1.5" fill="url(#logoMarkGrad)" />
    </svg>
  )
}

export function LogoIcon({ size = 20, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="logoIconGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="100%" stopColor="#a855f7" />
        </linearGradient>
      </defs>

      <circle cx="10" cy="10" r="8" stroke="url(#logoIconGrad)" strokeWidth="2" fill="none" />
      <circle cx="10" cy="10" r="2.5" fill="url(#logoIconGrad)" />
      <circle cx="10" cy="10" r="1" fill="#0f172a" />
    </svg>
  )
}

export default Logo
